<template>
  <div>
    <vue-element-loading :active="appLoading" :is-full-screen="true" />
    <v-snackbar v-model="showsnackbar" color="red" right>
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showsnackbar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-dialog
      v-model="cropImageDialog"
      persistent
      :width="
        $vuetify.breakpoint.name == 'xs' || $vuetify.breakpoint.name == 'sm'
          ? '100vw'
          : $vuetify.breakpoint.name == 'md'
          ? '80vw'
          : $vuetify.breakpoint.name == 'lg'
          ? '50vw'
          : '40vw'
      "
    >
      <v-card>
        <v-layout wrap justify-center pa-2>
          <v-flex xs12>
            <ImageCropper
              :image="currentImage"
              cropwidth="400"
              cropheight="300"
              :key="currentImage"
              @stepper="imageCropper"
            />
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>
    <v-layout justify-center wrap>
      <v-flex xs12>
        <v-card class="mb-1">
          <v-card-title>Seller Edit </v-card-title>
        </v-card>
        <v-card class="mb-1 pb-8" min-height="32em">
          <v-container>
            <v-form ref="profileForm" v-model="valid" lazy-validation>
              <v-row>
                <v-col cols="12" sm="6" md="4">
                  <v-text-field
                    v-model="shopName"
                    label="Shop Name"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <v-text-field
                    v-model="contactPerson"
                    label="Contact Person"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <v-text-field v-model="phone" label="Phone"></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="2">
                  <v-text-field
                    v-model="pincode"
                    label="Pincode"
                    readonly
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-text-field
                    v-model="place"
                    label="Place"
                    readonly
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <v-text-field
                    v-model="city"
                    label="City"
                    readonly
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <v-select
                    dense
                    v-model="category"
                    class="mt-5"
                    label="Category"
                    :items="categoryArray"
                    item-text="name"
                    item-value="_id"
                  ></v-select>
                </v-col>
                <v-col cols="12" sm="6" md="8">
                  <v-select
                    dense
                    multiple
                    v-model="subcategory"
                    class="mt-5"
                    label="SubCategory"
                    :items="subcategoryArray"
                    item-text="name"
                    item-value="_id"
                  ></v-select>
                </v-col>
                <v-col cols="12" style="color: grey">Bank Details</v-col>
                <v-col cols="12" sm="6" md="4">
                  <v-text-field
                    v-model="accountHolder"
                    label="Account Holder"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <v-text-field
                    v-model="accountNo"
                    label="Account Number"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <v-text-field v-model="bank" label="Bank"></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <v-text-field v-model="branch" label="Branch"></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <v-text-field v-model="ifsc" label="IFSC Code"></v-text-field>
                </v-col>
                <v-col cols="12" style="color: grey">Social media links</v-col>
                <v-col cols="12" sm="6" md="4">
                  <v-text-field
                    v-model="facebook"
                    label="Facebook"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <v-text-field
                    v-model="instagram"
                    label="Instagram"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <v-text-field
                    v-model="whatsapp"
                    label="Whatsapp"
                  ></v-text-field>
                </v-col>
                <v-layout justify-start wrap pl-2 pb-5>
                  <v-flex xs12>
                    <img
                      v-if="imagePreview"
                      :src="imagePreview"
                      v-show="showPreview"
                      width="390px"
                      height="150px"
                      class="align-center"
                      contain
                    />
                    <img
                      v-else
                      :src="baseURL + '/file/get/' + seller.coverPhoto"
                      width="390px"
                      height="150px"
                      class="align-center"
                      contain
                    />
                  </v-flex>
                  <v-flex xs12 sm7 md6 lg6>
                    <v-btn
                      width="180px"
                      block
                      tile
                      depressed
                      :ripple="false"
                      class="text-capitalize"
                      color="#F6F5FF"
                      @click="$refs.showImage.click()"
                    >
                      <v-layout justify-center wrap>
                        <v-flex xs2 sm2 md2 text-left>
                          <v-icon style="color: #000000">mdi-upload</v-icon>
                        </v-flex>
                        <v-flex xs10 sm8 md10>
                          <span class="image">Upload Cover Image</span>
                        </v-flex>
                      </v-layout>
                    </v-btn>
                    <input
                      v-show="false"
                      accept="image/*"
                      id="file"
                      ref="showImage"
                      multiple="multiple"
                      type="file"
                      @change="showImage"
                    />
                  </v-flex>
                </v-layout>
                <v-layout wrap>
                  <v-flex md8 lg8 pl-3 text-left>
                    <v-card pr-4flat tile outlined>
                      <v-layout wrap>
                        <v-flex pl-2 md8 lg8>
                          <v-layout wrap>
                            <v-flex
                              pt-2
                              md6
                              v-for="(item, i) in seller.shopImages"
                              :key="i"
                              px-2
                              class="hidden-sm-and-down"
                            >
                              <v-badge small overlap avatar color="#FF1313">
                                <template v-slot:badge>
                                  <v-avatar>
                                    <v-icon small @click="removePhotos(i)"
                                      >mdi-close</v-icon
                                    >
                                  </v-avatar>
                                </template>
                                <v-img
                                  v-if="item"
                                  :src="baseURL + '/file/get/' + item"
                                  height="44px"
                                  width="44px"
                                  contain
                                >
                                </v-img>
                              </v-badge>
                            </v-flex>
                          </v-layout>
                          <v-layout wrap>
                            <v-flex
                              lg6
                              md6
                              v-for="(item, i) in imageArray"
                              :key="i"
                              px-2
                              class="hidden-sm-and-down"
                            >
                              <v-badge small overlap avatar color="#FF1313">
                                <template v-slot:badge>
                                  <v-avatar>
                                    <v-icon small @click="removeImageArray(i)"
                                      >mdi-close</v-icon
                                    >
                                  </v-avatar>
                                </template>
                                <v-img :src="item" height="44px" width="44px">
                                </v-img>
                              </v-badge>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-card>
                    <br />
                    <span>
                      <v-btn
                        small
                        :ripple="false"
                        id="pro_pic"
                        class="text-capitalize"
                        color="#EFEFEF "
                        width="80%"
                        @click="$refs.files.click()"
                      >
                        <span style="font-size: 12px">Upload Shop Image</span>
                      </v-btn>
                      <input
                        v-show="false"
                        accept="image/*"
                        id="file"
                        ref="files"
                        multiple="multiple"
                        type="file"
                        @change="uploadImages"
                      />
                    </span>
                  </v-flex>
                </v-layout>
                <v-col cols="12">
                  <v-layout justify-center wrap>
                    <v-flex xs12 py-3>
                      <span class="head">Select location</span>
                    </v-flex>
                    <v-flex xs12>
                      <div id="map44"></div>
                    </v-flex>
                  </v-layout>
                </v-col>
                <v-row class="justify-center" style="padding-top: 80px">
                  <v-btn
                    :disabled="!valid"
                    outlined
                    color="red"
                    @click="validate()"
                  >
                    Update Data
                  </v-btn>
                </v-row>
                <v-col cols="12">
                  <v-divider></v-divider>
                </v-col>
                <v-col
                  cols="12"
                  style="font-weight: bold; font-size: 24px"
                  class="text-center"
                  >Working Hours</v-col
                >
                <WorkingHours :storage="this.$route.query.seller" />
              </v-row>
            </v-form>
          </v-container>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>
<script
    src="https://maps.googleapis.com/maps/api/js?libraries=places&key=AIzaSyCaccNxbzwR9tMvkppT7bT7zNKjChc_yAw&libraries=visualization,drawing">
</script>
<script>
var map = [];
var pincode = "";
var city = "";
var place = "";
import axios from "axios";
import WorkingHours from "./workingHours";
import ImageCropper from "@/components/commonComponents/imageCropper";

export default {
  components: {
    WorkingHours,
    ImageCropper,
  },
  data() {
    return {
      sp: [],
      timeout: 3000,
      marker: [],
      msg: "",
      latt: 0,
      lonn: 0,
      maps: null,
      showSnackBar: false,
      flag: true,
      ServerError: false,
      image: null,
      imagePreview: "",
      showPreview: false,
      file: null,
      appLoading: false,
      showsnackbar: false,
      phone: null,
      msg: null,
      valid: true,
      categoryArray: [],
      subcategoryArray: [],
      category: [],
      subcategory: [],
      city: null,
      contactPerson: null,
      pincode: null,
      place: null,
      shopName: null,
      email: null,
      accountHolder: null,
      accountNo: null,
      bank: null,
      branch: null,
      ifsc: null,
      facebook: "",
      instagram: "",
      whatsapp: null,
      seller: [],
      lat: null,
      lon: null,
      formData: new FormData(),
      deleteImageArrayDialog: false,
      imageArray: [],
      Images: new FormData(),
      delFormData: new FormData(),
      cropImageDialog: false,
      currentImage: null,
      singleSubcatData: {},
      imageCount: 0,
      Rules: [(v) => !!v || "Required"],
      nameRules: [
        (v) => !!v || "Name is required",
        (v) => (v && v.length <= 15) || "Name must be less than 15 characters",
      ],
      emailRules: [
        (v) => !!v || "Email is Required",
        (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
      ],
      phoneRules: [
        (v) => !!v || "Phone Number is Required",
        (v) => (v && v.length <= 10) || "Number must be less than 11",
        (v) => (v && v.length >= 10) || "Number must be grater than 10",
        (v) => /^\d{10}$/.test(v) || "Phone must be number",
      ],
      pinRules: [
        (v) => !!v || "Pincode is Required",
        (v) => /^(\d{4}|\d{6})$/.test(v) || "Pincode must be valid",
      ],
      ifscRules: [
        (v) => !!v || "IFSC Code is Required",
        (v) =>
          /[A-Z|a-z]{4}[0][a-zA-Z0-9]{6}$/.test(v || "IFSC Code must be valid"),
      ],
      accRules: [
        (v) => !!v || "Account Number is Required",
        (v) =>
          /^([0-9]{11})|([0-9]{2}-[0-9]{3}-[0-9]{6})$/.test(v) ||
          "Account Number must be valid",
      ],
    };
  },
  mounted: function () {
    this.getData();
    this.getCategory();
    this.getMap();
    this.getUser();
    // this.getSubcategory();
  },
  watch: {
    category() {
      this.getSubcategory();
    },
  },
  methods: {
    map(window_data) {
      this.lat = window_data.lat;
      this.lon = window_data.lon;
      this.pincode = window_data.pincode;
      this.city = window_data.city;
    },
    validate() {
      if (this.$refs.profileForm.validate()) {
        this.edit();
      }
    },
    imageCropper(payload) {
      this.cropImageDialog = payload.dialog;
      if (payload.image) {
        this.collectImages(payload.image);
      }
    },
    collectImages(image) {
      this.selectedFiles = image;
      this.Images.append("image", this.selectedFiles);
      this.formData.append("shopImages", this.selectedFiles);
      var img = new Image();
      img.src = window.URL.createObjectURL(image);
      img.onload = () => {
        const urls = URL.createObjectURL(image);
        this.imageArray.push(urls);
        this.imageCount =
          this.seller.shopImages.length + this.imageArray.length;
        if (this.imageArray) {
          this.image = this.imageArray[0];
        }
      };
    },
    getData() {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/user/view/" + this.$route.query.seller,
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.seller = response.data.data.sellerid;
          this.phone = response.data.data.phone;
          this.contactPerson = this.seller.contactPerson;
          this.shopName = this.seller.shopName;
          this.city = this.seller.city;
          this.pincode = this.seller.pincode;
          this.place = this.seller.place;
          this.email = this.seller.email;
          this.bank = this.seller.bankDetails.bank;
          this.accountHolder = this.seller.bankDetails.accountHolder;
          this.branch = this.seller.bankDetails.branch;
          this.ifsc = this.seller.bankDetails.ifsc;
          this.accountNo = this.seller.bankDetails.accountNo;
          this.facebook = this.seller.socialmedialinks.facebook;
          this.instagram = this.seller.socialmedialinks.instagram;
          this.whatsapp = this.seller.socialmedialinks.whatsapp;
          this.category = this.seller.category[0]._id;
          for (var i = 0; i < this.seller.subcategory.length; i++) {
            this.subcategory.push(this.seller.subcategory[i]);
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    edit() {
      var data = {};
      data["city"] = this.city;
      data["place"] = this.place;
      data["shopName"] = this.shopName;
      data["contactPerson"] = this.contactPerson;
      data["email"] = this.email;
      data["phone"] = this.phone;
      data["pincode"] = this.pincode;
      data["category"] = this.category;
      data["subcategory"] = this.subcategory;
      data["accountHolder"] = this.accountHolder;
      data["accountNo"] = this.accountNo;
      data["bank"] = this.bank;
      data["branch"] = this.branch;
      data["ifsc"] = this.ifsc;
      data["facebook"] = this.facebook;
      data["instagram"] = this.instagram;
      data["whatsapp"] = this.whatsapp;
      data["lat"] = this.lat;
      data["lon"] = this.lon;
      data["uid"] = this.$route.query.seller;
      axios({
        method: "POST",
        url: "/admin/seller/edit",
        data: data,
        headers: {
          token: localStorage.getItem("token"),
        },
      }).then((response) => {
        if (response.data.status == true) {
          this.msg = "Updated Successfully";
          this.showsnackbar = true;
          if (this.imagePreview) {
            this.uploadImage();
          }
          if (this.selectedFiles) this.uploadAllImages();
          this.getData();
        } else {
          this.show = false;
          this.msg = "Updated Successfully";
          this.showsnackbar = true;
        }
      });
    },
    getMap() {
      var vm = this;
      var geocoder;
      geocoder = new google.maps.Geocoder();
      const gmap = new google.maps.Map(document.getElementById("map44"), {
        center: { lat: 20.5937, lng: 78.9629 },
        zoom: 5,
      });
      this.maps = gmap;
      google.maps.event.addListener(this.maps, "click", (e) => {
        geocoder.geocode(
          {
            latLng: e.latLng,
          },
          function (results, status) {
            if (status == google.maps.GeocoderStatus.OK) {
              if (results[0]) {
                // console.log(results[0], "results");
                vm.city = null;
                map = results[0].address_components;
                for (var i = 0; i < map.length; i++) {
                  if (map[i].types.includes("postal_code")) {
                    vm.pincode = map[i].long_name;
                    // console.log("pincode is", vm.pincode);
                  }
                  if (
                    map[i].types.includes("political") ||
                    map[i].types.includes("locality")
                  ) {
                    if (vm.city == null) {
                      vm.city = map[i].long_name;
                      // console.log("city is", vm.city);
                    }
                  }
                }
                vm.place = results[0].formatted_address;
              } else {
                alert("No results found");
              }
            } else {
              alert("Geocoder failed due to: " + status);
            }
          }
        );
        this.city = vm.city;
        this.pincode = vm.pincode;
        this.mark(e);
      });
      console.log("test", this.maps);
      this.marker = new google.maps.Marker({
        map: this.maps,
        title: "Hello World!",
      });
    },
    mark(event) {
      // console.log("eve", event);
      // console.log(cityy, "   ", pincodee);
      this.latt = null;
      this.lonn = null;
      this.marker.setMap(null);
      this.latt = event.latLng.lat();
      this.lonn = event.latLng.lng();
      // console.log("mark lt is", this.latt);
      // console.log("mark ln is", this.lonn);

      this.marker = new google.maps.Marker({
        position: { lat: this.latt, lng: this.lonn },
        map: this.maps,
        title: "Hello World!",
      });
    },
    getUser() {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/user/view/" + this.$route.query.seller,
        headers: {
          token: localStorage.getItem("token"),
        },
      }).then((response) => {
        if (response.data.status) {
          if (response.data.data.sellerid.location) {
            this.marker.setMap(null);
            this.latt = response.data.data.sellerid.location[1];
            this.lonn = response.data.data.sellerid.location[0];
            this.marker = new google.maps.Marker({
              position: { lat: this.latt, lng: this.lonn },
              map: this.maps,
              title: "Hello World!",
            });
          }
          this.appLoading = false;
        } else {
          alert("failed to get email");
        }
      });
    },
    showImage(e) {
      this.file = e.target.files[0];
      var reader = new FileReader();
      reader.onload = (e) => {
        this.$refs.showImage.value = null;
        this.imagePreview = e.target.result;
      };
      if (this.file.size > 2145728) {
        this.msg = "File Should be less than 2MB";
        this.showSnackBar = true;
        return;
      }
      this.showPreview = true;
      if (this.file) {
        if (/\.(jpe?g|png|gif)$/i.test(this.file.name)) {
          reader.readAsDataURL(this.file);
        }
      }
    },
    uploadImage() {
      this.appLoading = true;
      this.formData.append("uid", this.$route.query.seller);
      this.formData.append("coverPhoto", this.file);
      axios({
        method: "POST",
        url: "/admin/seller/edit",
        data: this.formData,
        headers: {
          "Content-Type": "multipart/form-data",
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status == true) {
            this.formDataCover = new FormData();
            this.msg = "Upload Successfully";
            this.showsnackbar = true;
            this.dialog = false;
            this.getData();
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.msg = "Can't Upload Cover Image.. Please Try Again Later";
          this.showsnackbar = true;
          console.log(err);
        });
    },
    removePhotos(i) {
      var Data = {};
      var name = [];
      name.push(this.seller.shopImages[i]);
      this.seller.shopImages.splice(i, 1);
      Data["uid"] = this.$route.query.seller;
      Data["key"] = name;
      axios({
        method: "POST",
        url: "/admin/shop/images/delete",
        data: Data,
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status == true) {
            this.showsnackbar = true;
            this.msg = "Deleted Successfully";
          } else {
            this.msg = "Can't Delete Image";
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    uploadImages(event) {
      if (this.imageCount < 4) {
        this.currentImage = URL.createObjectURL(event.target.files[0]);
        this.cropImageDialog = true;
      } else {
        this.msg = "Maximum image limit exceeded!";
        this.showsnackbar = true;
        return;
      }
    },
    uploadAllImages() {
      this.formData.append("uid", this.$route.query.seller);
      axios({
        method: "POST",
        url: "/admin/seller/edit",
        data: this.formData,
        headers: {
          "Content-Type": "multipart/form-data",
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status == true) {
            this.formData = new FormData();
            this.msg = "Upload Successfully";
            this.showsnackbar = true;
            this.dialog = false;
            this.getData();
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    getCategory() {
      this.appLoading = true;
      axios({
        url: "/category/list",
        method: "GET",
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.categoryArray = response.data.data;
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    getSubcategory() {
      axios({
        url: "/subcategory/list/" + this.category,
        method: "GET",
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.subcategoryArray = response.data.data;
        })
        .catch((err) => {
          this.ServerError = true;
          this.appLoading = false;
          console.log(err);
        });
    },
    removeImageArray(i) {
      var values = this.formData.getAll("shopImages");
      values.splice(i, 1);
      this.formData.set("shopImages", values);
      console.log(this.formData);
      this.imageArray.splice(i, 1);
      this.deleteImageArrayDialog = false;
    },
  },
};
</script>
<style>
#map44 {
  height: 600px;
  width: 100%;
  margin: 0px;
  padding: 0px;
}
</style>